import { c as _c } from "react-compiler-runtime";
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnCallToActionContext = /*#__PURE__*/createContext(null);
export const ProvideColumnCallToAction = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = /*#__PURE__*/_jsx(ColumnCallToActionContext.Provider, {
      value: value,
      children: children
    });
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useColumnCallToAction = () => {
  return useContext(ColumnCallToActionContext);
};